var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-my-pages-template',{attrs:{"title":_vm.t('invoicesTitle'),"text":_vm.t('invoicesSubTitle')}},[_c('oie-my-invoices-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }